import React from 'react'
import MaterialSymbol from '../material-symbol'

const LocalHospital = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="local_hospital" {...props} />
))

LocalHospital.displayName = 'LocalHospital'

export default LocalHospital
